import { getAccountPermission } from '@bingads-webui-clientcenter/repository-utils';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import { AccountUtils, Constants } from '@bingads-webui-clientcenter/entity-utils';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import { initCcJsData } from '../global-init/init-cc-js-data';

const { SecurityAction, PaymentOption, AccountMode } = Constants;
const { extendAccount } = AccountUtils;
const securityActions = [
  SecurityAction.CampaignManagementFullControl,
  SecurityAction.ForceBilling,
  SecurityAction.AccountUpdate,
];
const CAMPAIGN_PAGE_SIZE = 10000;
const defaultCampaignBudgetSummaryGridPageSize = 10;
const defaultCampaignBudgetSummaryGridPageNumber = 1;

export function fetchDataForBudgetCenter({
  serverContext,
  queryParam,
}) {
  const { jsDataCcRest: ccJsData } = initCcJsData({ serverContext });
  const { cid: cidString, aid: aidString, campaignId: campaignIdString } = queryParam.values;
  const cid = Number(cidString);
  const aid = Number(aidString);
  const campaignId = Number(campaignIdString);
  const account = extendAccount({
    ...serverContext.CurrentAccount,
    CurrencyType: serverContext.CurrentAccount.CurrencyCode, // match CCUI AccountSerializationProxy
  });
  const isValidAccountId = aid > 0 && account.hasPaymentOption() && (account.AccountMode === AccountMode.Legacy || account.AccountMode === AccountMode.Expert);

  if (!isValidAccountId) {
    return;
  }

  const isAccountScope = (aid > 0) && !(campaignId > 0);
  const budgetInsightsAndAlertsId = `AID${aid}_CampaignID${campaignId || ''}`;
  const ioAuthzId = `CID${cid}_AID${aid}`;

  getAccountPermission(ccJsData, { accountId: aid, securityActions });
  ccJsData.BudgetInsightsAndAlerts.find(budgetInsightsAndAlertsId, { params: { aid, campaignId } });
  jsData.Campaign.findAll({
    query: {
      $select: 'Id, Name, DeliveryStatus',
      $skip: 0,
      $top: CAMPAIGN_PAGE_SIZE,
      $orderby: 'Name asc',
    },
  });

  if (account.hasOneOfPaymentOptions([PaymentOption.Invoice])) {
    ccJsData.InsertionOrderPermission.find(ioAuthzId, { params: { cid, aid } });
  }

  if (account.TimeZone) {
    const timeZone = toIANATimeZone(fromLegacyTimeZone(account.TimeZone));
    const formatter = new Intl.DateTimeFormat( // StandardDateFormat M/d/yyyy
      'en-US',
      {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }
    );
    const monthKeyString = formatter.format(new Date());
    const accountInfoDataId = `AID${aid}_MonthKey${monthKeyString}`;
    const campaignInfoDataId = `AID${aid}_CampaignID${campaignId}_MonthKey${monthKeyString}`;

    if (monthKeyString) {
      if (isAccountScope) {
        ccJsData.AccountBudgetCenterInformation.find(accountInfoDataId, { params: { aid, monthKey: monthKeyString } });
        ccJsData.CampaignBudgetSummaryGrid.findAll({
          aid,
          monthKey: monthKeyString,
          limit: defaultCampaignBudgetSummaryGridPageSize,
          offset: (defaultCampaignBudgetSummaryGridPageNumber - 1) * defaultCampaignBudgetSummaryGridPageSize,
        });
      } else {
        ccJsData.CampaignBudgetCenterInformation.find(campaignInfoDataId, { params: { aid, campaignId, monthKey: monthKeyString } });
      }
    }
  }
}
